__turbopack_context__.v({
  "action": "SuggestionBanner-module-scss-module___CTcUq__action",
  "banner": "SuggestionBanner-module-scss-module___CTcUq__banner",
  "description": "SuggestionBanner-module-scss-module___CTcUq__description",
  "fade-in": "SuggestionBanner-module-scss-module___CTcUq__fade-in",
  "no-transform": "SuggestionBanner-module-scss-module___CTcUq__no-transform",
  "preamble": "SuggestionBanner-module-scss-module___CTcUq__preamble",
  "readMoreButton": "SuggestionBanner-module-scss-module___CTcUq__readMoreButton",
  "rotate": "SuggestionBanner-module-scss-module___CTcUq__rotate",
});
